import React, { useMemo, useRef } from 'react';
import { StyledOfferSection, StyledOfferTitle } from './style';
import { ProductMadnessSpecialOfferMainProduct as MainProduct } from '../Products/main';
import { Gradient, MainProductData } from 'utils/types';
import { EFontWeights } from 'utils/enums';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

interface IProductMadnessOfferSection {
  title: string;
  textColor: Gradient;
  fontSize: number;
  fontWeight: EFontWeights;
  subTitle: string;
  subTitleColor: Gradient;
  subTitleSize: number;
  subTitleWeight: EFontWeights;
  mainProduct: MainProductData | null;
  gap: string;
  children: JSX.Element;
}

const trimAfterSecondNewline = (text: string): string[] => {
  const parts = text.split('\n');
  return parts.slice(0, 2);
};

export const ProductMadnessOfferSection: React.FC<
  IProductMadnessOfferSection
> = ({
  title,
  textColor,
  fontSize,
  fontWeight,
  subTitle,
  subTitleColor,
  subTitleSize,
  subTitleWeight,
  mainProduct,
  gap,
  children,
}) => {
  const refOfferSection = useRef<HTMLDivElement | null>(null);

  const right = refOfferSection?.current?.offsetWidth
    ? 22624 / Math.pow(refOfferSection.current.offsetWidth, 1.5)
    : 10;

  const trimmedSubTitles = useMemo(
    () => (subTitle ? trimAfterSecondNewline(subTitle) : ''),
    [subTitle],
  );

  return (
    <StyledOfferSection ref={refOfferSection} right={right} gap={gap}>
      {title && (
        <StyledOfferTitle
          title={title}
          className="main-title"
          textColor={textColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
          isSubTitle={false}
        >
          <AutoTextSize
            maxFontSizePx={20}
            minFontSizePx={6}
            className="title"
            mode="oneline"
          >
            {title}
          </AutoTextSize>
        </StyledOfferTitle>
      )}
      {trimmedSubTitles &&
        trimmedSubTitles?.length > 0 &&
        trimmedSubTitles.map((text) => (
          <StyledOfferTitle
            title={text}
            className="sub-title"
            textColor={subTitleColor}
            fontSize={subTitleSize}
            fontWeight={subTitleWeight}
            isSubTitle={true}
          >
            <AutoTextSize
              maxFontSizePx={16}
              minFontSizePx={6}
              className="title"
              mode="oneline"
            >
              {text}
            </AutoTextSize>
          </StyledOfferTitle>
        ))}
      {mainProduct && (
        <MainProduct
          quantityDisplay={mainProduct.quantityDisplay}
          images={mainProduct.images}
        />
      )}
      {children}
    </StyledOfferSection>
  );
};
